import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { useTawkTo } from './hooks/useTawkTo';
import { useDocumentTitle } from './hooks/useDocumentTitle';
import { business } from './data/business';
export function App() {
  useDocumentTitle(`${business.brand} — ${business.legalName}`);
  useTawkTo();
  return <BrowserRouter data-id="element-0" data-mp="2rit1j0zlpmob">
      <Routes data-id="element-1" data-mp="2mlu9qp3etrta">
        <Route path="/" element={<Landing data-id="element-3" data-mp="2mmvj8p4s268w" />} data-id="element-2" data-mp="2mm2j470bqezq" />
        <Route path="/terminos-y-condiciones" element={<Terms data-id="element-5" data-mp="31agoopp4khjz" />} data-id="element-4" data-mp="2mndmw6trrmqu" />
        <Route path="/politica-de-privacidad" element={<Privacy data-id="element-7" data-mp="31ctfztgrw49p" />} data-id="element-6" data-mp="31ayq00qn9lyr" />
        <Route path="*" element={<Landing data-id="element-9" data-mp="2wjqgz5t882m4" />} data-id="element-8" data-mp="2wk06ksad07ra" />
      </Routes>
    </BrowserRouter>;
}